import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import mapProfileToProps from 'profile/containers/map_profile_to_props';
import { toggleTestimonials } from 'profile/ducks/view';
import Testimonials from 'profile/components/testimonials';

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    toggleTestimonials
  }, dispatch);
}

export default connect(mapProfileToProps, mapDispatchToProps)(Testimonials);



// WEBPACK FOOTER //
// ./profile/containers/testimonials.js